/**
 * @generated SignedSource<<242def68c521a06d08e97abe3b6e54d8>>
 * @relayHash 7dd41b75890de8b7747d4279b73c870f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba4ad4845320a0ea47ecacdfedb09d9bfa169e9c0e2808f18356778c3d224b55

import type { ConcreteRequest } from 'relay-runtime';
export type useBlogPostsQueryQuery$variables = {
  cql: string;
  first?: number | null | undefined;
  includeAdfBody: boolean;
  includeAdfExcerpt: boolean;
  includeAdfMediaToken: boolean;
  includeExcerpt: boolean;
  includeRenderedBody: boolean;
  includeRenderedExcerpt: boolean;
};
export type useBlogPostsQueryQuery$data = {
  readonly search: {
    readonly count: number | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly body: {
          readonly atlas_doc_format?: {
            readonly mediaToken: {
              readonly token: string | null | undefined;
            } | null | undefined;
            readonly value?: string | null | undefined;
          } | null | undefined;
          readonly view?: {
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly excerpt?: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName?: string | null | undefined;
            readonly profilePicture?: {
              readonly path: string;
            } | null | undefined;
          } | null | undefined;
          readonly createdDate: string | null | undefined;
          readonly lastUpdated: {
            readonly when: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly name: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly macroExcerpt?: {
          readonly atlasDocFormat?: string | null | undefined;
          readonly view?: string | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useBlogPostsQueryQuery = {
  response: useBlogPostsQueryQuery$data;
  variables: useBlogPostsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAdfBody"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAdfExcerpt"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAdfMediaToken"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExcerpt"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRenderedBody"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRenderedExcerpt"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "count"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "title"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = [
  {
    "kind": "Literal",
    "name": "fallbackToBody",
    "value": false
  }
],
v14 = {
  "condition": "includeExcerpt",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 500
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:500)"
    },
    {
      "concreteType": "ConfluenceMacroExcerptBody",
      "kind": "LinkedField",
      "name": "macroExcerpt",
      "plural": false,
      "selections": [
        {
          "condition": "includeRenderedExcerpt",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v13/*: any*/),
              "kind": "ScalarField",
              "name": "view",
              "storageKey": "view(fallbackToBody:false)"
            }
          ]
        },
        {
          "condition": "includeAdfExcerpt",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v13/*: any*/),
              "kind": "ScalarField",
              "name": "atlasDocFormat",
              "storageKey": "atlasDocFormat(fallbackToBody:false)"
            }
          ]
        }
      ]
    }
  ]
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v16 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "condition": "includeRenderedBody",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "view",
          "plural": false,
          "selections": (v15/*: any*/)
        }
      ]
    },
    {
      "condition": "includeAdfMediaToken",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "atlas_doc_format",
          "plural": false,
          "selections": [
            {
              "condition": "includeAdfBody",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v15/*: any*/)
            },
            {
              "concreteType": "EmbeddedMediaToken",
              "kind": "LinkedField",
              "name": "mediaToken",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "token"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v19 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v17/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v21 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    },
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "type": "KnownUser"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "type": "UnknownUser"
},
v24 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v25 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "lastUpdated",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useBlogPostsQueryQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v8/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useBlogPostsQueryQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v8/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7dd41b75890de8b7747d4279b73c870f",
    "id": "ba4ad4845320a0ea47ecacdfedb09d9bfa169e9c0e2808f18356778c3d224b55",
    "metadata": {},
    "name": "useBlogPostsQueryQuery",
    "operationKind": "query",
    "text": "query useBlogPostsQueryQuery($cql:String!,$first:Int,$includeRenderedBody:Boolean!,$includeAdfBody:Boolean!,$includeExcerpt:Boolean!,$includeRenderedExcerpt:Boolean!,$includeAdfExcerpt:Boolean!,$includeAdfMediaToken:Boolean!){search:confluence_search(cql:$cql,first:$first){count,nodes{content{id,title,type,excerpt(length:500)@include(if:$includeExcerpt)\n        macroExcerpt@include(if:$includeExcerpt){view(fallbackToBody:false)@include(if:$includeRenderedExcerpt),atlasDocFormat(fallbackToBody:false)@include(if:$includeAdfExcerpt)},body{view@include(if:$includeRenderedBody){value},atlas_doc_format@include(if:$includeAdfMediaToken){value@include(if:$includeAdfBody),mediaToken{token}}},labels{nodes{name,id}},links{webui,base},space{id,key,name},history{createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{displayName,profilePicture{path}}},createdDate,lastUpdated{when}}}}}}"
  }
};
})();

(node as any).hash = "1a723bde7f9f00beddb605bd428095e9";

export default node;
